
  //Local
 // baseURL: "http://localhost:8081/",
// baseURL: "https://aomapi-production.up.railway.app/",
 // Local
 //baseURL: "https://aomapi-production.up.railway.app/",

import axios from "axios";
import { auth } from '../firebase';

export const http = axios.create({
  baseURL: "https://aomapi-production.up.railway.app/",
});

http.interceptors.request.use(async config => {
  try {
    const user = auth.currentUser;
    
    
    if (user) {
      const idToken = await user.getIdToken();
      config.headers.Authorization = `Bearer ${idToken}`;
    } else {
      const idToken = localStorage.getItem('idToken');
      if (idToken) {
        config.headers.Authorization = `Bearer ${idToken}`;
      }
    }
  } catch (error) {
    console.error("Erro ao renovar token do Firebase", error);
  }
  
  return config;
}, error => {
  return Promise.reject(error);
});

export default http;